import BaseRestCollection from 'base/model/base_rest_collection'
import LetterElementModel from '@/modules/letter/model/letter_element_model'

export default BaseRestCollection.extend({
  model: LetterElementModel,

  constructor: function LetterElementCollection() {
    BaseRestCollection.apply(this, arguments)
  },
})
